module.exports = __webpack_public_path__ + "img/Tablet - 30.e3be5ccd.png";